import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {isMobile} from 'react-device-detect';
import BtnWhiteBlackBorderBigSize from '../Buttons/BtnWhiteBlackBorderBigSize';
import Config from '../../../Config';
import {prepareNewWindowUrl} from '../../../utilities/StringHelpers/StringHelpers';
import EpiContext from '@episerver/spa-core/Spa';

function ServiceButtons(props) {
  const isIdf = props.isIdf || false;
  const whatsappUrl = props?.whatsappUrl ? props?.whatsappUrl : 'https://cellcom.co.il/clm/16/20/';
  const hideLobbyUrl = props.hideLobbyUrl || false;
  const hideTitle = props.hideTitle || false;
  const tel = props.tel ? props.tel : window.Config.technicalSupportPhone;
  return (
    <div className='callBack-Service'>
      {!hideTitle && <span className='title-text'>נציגנו ישמחו לסייע לך</span>}

      <div
        className='service-btn'
        onClick={() => {
          prepareNewWindowUrl(whatsappUrl, EpiContext);
        }}>
        <span>
          <Image src={require('./images/wa.svg')} />
        </span>
        <span>לנציג שירות ב-WhatsApp</span>
      </div>
      {!isIdf && (
        <>
          <div className='service-btn'>
            <a href={isMobile ? `tel:${tel}` : ''}> חייגו {tel} לנציג שירות</a>
          </div>
          {!hideLobbyUrl && (
            <div
              className='service-btn footer'
              onClick={() => {
                EpiContext.navigateTo(Config.lobbyUrl);
              }}>
              <span>חזרה לאיזור האישי</span>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default ServiceButtons;
